
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1feRM", function(module, exports) {

$parcel$export(module.exports, "useIsDropdownOpen", () => $cd036afdcb934ada$export$f23a75298e125425);
$parcel$export(module.exports, "CreateBranchDropdown", () => $cd036afdcb934ada$export$2cbffad71321760a);
$parcel$export(module.exports, "default", () => $cd036afdcb934ada$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");

var $2gCtH = parcelRequire("2gCtH");

var $7wNl6 = parcelRequire("7wNl6");

var $80wkc = parcelRequire("80wkc");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $93Yeu = parcelRequire("93Yeu");

var $90yGq = parcelRequire("90yGq");

var $4R6GH = parcelRequire("4R6GH");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $7Qh8A = parcelRequire("7Qh8A");

var $gkNob = parcelRequire("gkNob");
const $cd036afdcb934ada$export$f23a75298e125425 = (isOpen = false)=>(0, $5uXOq.useState)(isOpen);
const $cd036afdcb934ada$var$entryPointParams = {};
const $cd036afdcb934ada$var$CreateBranchDropdownInner = ({ createBranchTargets: createBranchTargets, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideCreateBranchLinks: hideCreateBranchLinks = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $cd036afdcb934ada$export$f23a75298e125425();
    const [isBranchConfigOpen, setIsBranchConfigOpen] = (0, $5uXOq.useState)(false);
    const previousOpen = (0, $5uXOq.useRef)(false);
    const [, { getUserConfigBranchData: getUserConfigBranchData, setBranchData: setBranchData }] = (0, $7Qh8A.useBranchCommandBuilderStore)();
    const configButtonRef = (0, $5uXOq.useRef)(null);
    const accountId = (0, $90yGq.useAccountId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const issueId = (0, $4R6GH.fg)('relay-migration-issue-fields-summary') ? (0, $2gCtH.useIssueId)() : undefined;
    const [{ value: issueType }] = (0, $7wNl6.useIssueTypeField)({
        issueKey: issueKey
    });
    const [{ value: issueSummary }] = (0, $80wkc.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const menuGroupRef = (0, $5uXOq.useRef)(null);
    const [activeItemId, setActiveItemId] = (0, $5uXOq.useState)(null);
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'updateBranchNameFormatButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        setIsBranchConfigOpen(true);
    }, [
        createAnalyticsEvent
    ]);
    const handleOnHover = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'updateBranchNameFormatButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            if (isOpen) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'createBranchDropdown');
                setBranchData({
                    issueKey: issueKey,
                    issueSummary: issueSummary || '',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    issueType: issueType?.name || '',
                    projectKey: projectKey
                });
                getUserConfigBranchData(accountId);
                setTimeout(()=>{
                    if (!isBranchConfigOpen && menuGroupRef.current && (0, $4R6GH.fg)('dev_details_add_focus_to_list')) {
                        const firstMenuItem = menuGroupRef.current?.querySelector('[role="menuitem"]');
                        if (firstMenuItem) {
                            firstMenuItem.focus();
                            setActiveItemId(firstMenuItem.getAttribute('data-testid'));
                        }
                    }
                }, 0);
            } else {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'createBranchDropdown');
                isBranchConfigOpen && setIsBranchConfigOpen(false);
            }
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        createBranchTargets,
        isOpen,
        onOpenDropdown,
        accountId,
        getUserConfigBranchData,
        setBranchData,
        issueKey,
        issueSummary,
        issueType?.name,
        projectKey,
        isBranchConfigOpen
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (!(0, $4R6GH.fg)('dev_details_add_focus_to_list')) return;
        if (!menuGroupRef.current) return;
        const menuItems = Array.from(menuGroupRef.current.querySelectorAll('[role="menuitem"]'));
        if (menuItems.length === 0) return;
        const currentIndex = menuItems.findIndex((item)=>item === globalThis.document?.activeElement);
        switch(event.key){
            case 'ArrowDown':
                {
                    event.preventDefault();
                    const nextIndex = currentIndex < menuItems.length - 1 ? currentIndex + 1 : 0;
                    menuItems[nextIndex].focus();
                    // Update active item tracking using data-testid
                    setActiveItemId(menuItems[nextIndex].getAttribute('data-testid') || null);
                    break;
                }
            case 'ArrowUp':
                {
                    event.preventDefault();
                    const prevIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1;
                    menuItems[prevIndex].focus();
                    // Update active item tracking using data-testid
                    setActiveItemId(menuItems[prevIndex].getAttribute('data-testid') || null);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!isBranchConfigOpen && configButtonRef.current) configButtonRef.current.focus();
    }, [
        isBranchConfigOpen
    ]);
    const showCreateBranchLinkSection = !hideCreateBranchLinks && createBranchTargets.length > 0;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $gkNob.createBranchDropdownContentEntrypoint), $cd036afdcb934ada$var$entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            createBranchTargets: createBranchTargets,
            isBranchConfigOpen: isBranchConfigOpen,
            setIsBranchConfigOpen: setIsBranchConfigOpen,
            showCreateBranchLinkSection: showCreateBranchLinkSection,
            menuGroupRef: menuGroupRef,
            activeItemId: activeItemId,
            handleKeyDown: handleKeyDown,
            setIsOpen: setIsOpen,
            configButtonRef: configButtonRef,
            handleOnClick: handleOnClick,
            handleOnHover: handleOnHover
        }), [
        activeItemId,
        createBranchTargets,
        handleKeyDown,
        handleOnClick,
        handleOnHover,
        isBranchConfigOpen,
        setIsOpen,
        showCreateBranchLinkSection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        id: "create-branch-dropdown",
        zIndex: (0, $gwIPs.layers).modal + 1,
        placement: "bottom-end",
        shouldFlip: true,
        messageId: "development-summary-branch.ui.create-branch-dropdown.popup",
        messageType: "transactional",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>getDropdownTrigger({
                ...triggerProps,
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
            setIsBranchConfigOpen(false);
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "dev-panel-create-dropdown-content",
                packageName: "jira-development-summary-branch",
                fallback: null,
                runtimeProps: runtimeProps
            })
    });
};
const $cd036afdcb934ada$export$2cbffad71321760a = ({ createBranchTargets: createBranchTargets, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideCreateBranchLinks: hideCreateBranchLinks = false })=>{
    const scmProviderTypes = (0, $5uXOq.useMemo)(()=>createBranchTargets.map((target)=>target.applicationType), [
        createBranchTargets
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            scmProviderTypes: scmProviderTypes,
            singleScmProvider: createBranchTargets.length === 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd036afdcb934ada$var$CreateBranchDropdownInner, {
        createBranchTargets: createBranchTargets,
        onOpenDropdown: onOpenDropdown,
        getDropdownTrigger: getDropdownTrigger,
        hideCreateBranchLinks: hideCreateBranchLinks
    }));
};
var $cd036afdcb934ada$export$2e2bcd8739ae039 = $cd036afdcb934ada$export$2cbffad71321760a;

});
parcelRegister("7Qh8A", function(module, exports) {

$parcel$export(module.exports, "useBranchCommandBuilderStore", () => $71fb690573b498bf$export$931a712bc1008381);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5BU3N = parcelRequire("5BU3N");

var $18yLj = parcelRequire("18yLj");
const $71fb690573b498bf$export$e324594224ef24da = {
    setDefaultTemplates: $18yLj.setDefaultTemplates,
    setUserEnteredTemplate: $18yLj.setUserEnteredTemplate,
    setCaretPosition: $18yLj.setCaretPosition,
    insertPlaceholder: $18yLj.insertPlaceholder,
    removePlaceholder: $18yLj.removePlaceholder,
    saveUserConfigBranchData: $18yLj.saveUserConfigBranchData,
    setInitialState: $18yLj.setInitialState,
    getUserConfigBranchData: $18yLj.getUserConfigBranchData,
    setBranchData: $18yLj.setBranchData,
    setFocusTagIndex: $18yLj.setFocusTagIndex,
    setRestoreFocus: $18yLj.setRestoreFocus,
    setEmptyTextStarterTemplates: $18yLj.setEmptyTextStarterTemplates,
    restoreFocusAfterDeletingAllText: $18yLj.restoreFocusAfterDeletingAllText,
    setIsGitCommandIncluded: $18yLj.setIsGitCommandIncluded
};
const $71fb690573b498bf$var$defaultTemplates = Array.from((0, $5BU3N.initialTemplates));
const $71fb690573b498bf$export$62680b65e63e14ec = {
    branchNameTemplate: $71fb690573b498bf$var$defaultTemplates,
    version: 'v2',
    isGitCommandIncluded: true
};
const $71fb690573b498bf$export$d4c72bab9d6cc13a = {
    // React.js: Getting "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."
    // we need to update the key of the parent element to fix this issue
    // uniqueKey is used only as a React key, so we hardcode it - it does not need to change between loads
    uniqueKey: 'initial-key',
    writeOnlyTemplates: $71fb690573b498bf$var$defaultTemplates,
    readAndWriteTemplates: $71fb690573b498bf$var$defaultTemplates,
    get originalTemplates () {
        return $71fb690573b498bf$var$defaultTemplates;
    },
    caretPosition: {
        templateIndex: 2,
        characterIndex: 0
    },
    isLoading: false,
    isSaving: false,
    restoreFocus: false,
    saveError: null,
    branchData: {
        issueKey: '',
        issueSummary: '',
        issueType: '',
        projectKey: ''
    },
    focusTagIndex: 0
};
const $71fb690573b498bf$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'branchCommandBuilderStore',
    initialState: $71fb690573b498bf$export$d4c72bab9d6cc13a,
    actions: $71fb690573b498bf$export$e324594224ef24da
});
const $71fb690573b498bf$export$931a712bc1008381 = (0, $3sQ5x.createHook)($71fb690573b498bf$export$390f32400eaf98c9);

});
parcelRegister("5BU3N", function(module, exports) {

$parcel$export(module.exports, "UPDATE_BRANCH_NAME_FORMAT_TITLE_TEST_ID", () => $eaa7cf347c6ebe70$export$b7fad45c54770da);
$parcel$export(module.exports, "PREVIEW_TITLE_TEST_ID", () => $eaa7cf347c6ebe70$export$22ee487ea97a4c);
$parcel$export(module.exports, "RESET_BUTTON_TEST_ID", () => $eaa7cf347c6ebe70$export$486dec2b953e5ae);
$parcel$export(module.exports, "CANCEL_BUTTON_TEST_ID", () => $eaa7cf347c6ebe70$export$3436ddf8bf2120bc);
$parcel$export(module.exports, "SAVE_BUTTON_TEST_ID", () => $eaa7cf347c6ebe70$export$ed485395681ff340);
$parcel$export(module.exports, "COPY_PAGE_GIT_COMMAND_LENGTH_ERROR_MESSAGE_TEST_ID", () => $eaa7cf347c6ebe70$export$6988540077064b73);
$parcel$export(module.exports, "SAVE_ERROR_MESSAGE_TEST_ID", () => $eaa7cf347c6ebe70$export$3a82a302bc1421a9);
$parcel$export(module.exports, "PROPERTY_KEY", () => $eaa7cf347c6ebe70$export$bb10a02fc2feb574);
$parcel$export(module.exports, "GIT_COMMAND_SECTION_TEST_ID", () => $eaa7cf347c6ebe70$export$93876e35991f382d);
$parcel$export(module.exports, "tags", () => $eaa7cf347c6ebe70$export$8b7a896ae75accbf);
$parcel$export(module.exports, "initialTemplates", () => $eaa7cf347c6ebe70$export$1f6def93b12b1d48);
$parcel$export(module.exports, "TAB", () => $eaa7cf347c6ebe70$export$f1c9dd0f5207dd5e);
$parcel$export(module.exports, "ARROW_DOWN", () => $eaa7cf347c6ebe70$export$59f214baefff6196);
$parcel$export(module.exports, "ARROW_UP", () => $eaa7cf347c6ebe70$export$8188339dbe6c99c4);
$parcel$export(module.exports, "ARROW_LEFT", () => $eaa7cf347c6ebe70$export$8d4f84cc5dc5fc15);
$parcel$export(module.exports, "ARROW_RIGHT", () => $eaa7cf347c6ebe70$export$e9510a4613bb01df);
$parcel$export(module.exports, "ENTER", () => $eaa7cf347c6ebe70$export$806b905ec7df742f);
$parcel$export(module.exports, "BACKSPACE", () => $eaa7cf347c6ebe70$export$acae31b32a99bba9);
$parcel$export(module.exports, "DELETE", () => $eaa7cf347c6ebe70$export$4bd2facc4a3e6aa1);
$parcel$export(module.exports, "TAB_KEY_CODE", () => $eaa7cf347c6ebe70$export$c8fc15cbe86018cf);
$parcel$export(module.exports, "ARROW_DOWN_KEY_CODE", () => $eaa7cf347c6ebe70$export$ef4126220d897037);
$parcel$export(module.exports, "ARROW_UP_KEY_CODE", () => $eaa7cf347c6ebe70$export$350d8b99a00c926e);
$parcel$export(module.exports, "ARROW_LEFT_KEY_CODE", () => $eaa7cf347c6ebe70$export$e774cc0768ea4dc1);
$parcel$export(module.exports, "ARROW_RIGHT_KEY_CODE", () => $eaa7cf347c6ebe70$export$31ed5928f4dcb259);
$parcel$export(module.exports, "ENTER_KEY_CODE", () => $eaa7cf347c6ebe70$export$772f5b3bcf01463);
$parcel$export(module.exports, "BACKSPACE_KEY_CODE", () => $eaa7cf347c6ebe70$export$707d117a1ef29221);
$parcel$export(module.exports, "DELETE_KEY_CODE", () => $eaa7cf347c6ebe70$export$229ec1b1cfee860b);
$parcel$export(module.exports, "GIT_COMMAND_MAX_LENGTH", () => $eaa7cf347c6ebe70$export$4f8e512aaddfeb04);
$parcel$export(module.exports, "GIT_CHECKOUT_NEW_BRANCH", () => $eaa7cf347c6ebe70$export$1817f9c591be5d87);
$parcel$export(module.exports, "ERROR", () => $eaa7cf347c6ebe70$export$103bedf43ba882db);
$parcel$export(module.exports, "WARNING", () => $eaa7cf347c6ebe70$export$64fdd419ec8dbc36);
$parcel$export(module.exports, "FORBIDDEN_GIT_BRANCH_EXPRESSIONS", () => $eaa7cf347c6ebe70$export$4f363a1643a5c272);

var $5J7Qx = parcelRequire("5J7Qx");
const $eaa7cf347c6ebe70$export$b7fad45c54770da = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.section-title-update-branch-name-format';
const $eaa7cf347c6ebe70$export$22ee487ea97a4c = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.section-title-preivew';
const $eaa7cf347c6ebe70$export$486dec2b953e5ae = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.reset-button';
const $eaa7cf347c6ebe70$export$3436ddf8bf2120bc = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.button-cancel';
const $eaa7cf347c6ebe70$export$ed485395681ff340 = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.button-save';
const $eaa7cf347c6ebe70$export$6988540077064b73 = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.git-command-error-message-copy-page';
const $eaa7cf347c6ebe70$export$3a82a302bc1421a9 = 'development-summary-branch.ui.create-branch-dropdown.copy-branch-command.branch-command-builder.save-error-message';
const $eaa7cf347c6ebe70$export$bb10a02fc2feb574 = 'create-branch-config';
const $eaa7cf347c6ebe70$export$93876e35991f382d = 'development-summary-branch.ui.create-branch-dropdown.git-command-section';
const $eaa7cf347c6ebe70$export$8b7a896ae75accbf = [
    (0, $5J7Qx.PlaceholderEnum).ISSUE_KEY,
    (0, $5J7Qx.PlaceholderEnum).ISSUE_SUMMARY,
    (0, $5J7Qx.PlaceholderEnum).ISSUE_SUMMARY_SHORT,
    (0, $5J7Qx.PlaceholderEnum).ISSUE_TYPE,
    (0, $5J7Qx.PlaceholderEnum).PROJECT_KEY
];
const $eaa7cf347c6ebe70$export$1f6def93b12b1d48 = [
    {
        type: (0, $5J7Qx.BranchTemplateType).TEXT,
        value: ''
    },
    {
        type: (0, $5J7Qx.BranchTemplateType).PLACEHOLDER,
        value: (0, $5J7Qx.PlaceholderEnum).ISSUE_KEY
    },
    {
        type: (0, $5J7Qx.BranchTemplateType).TEXT,
        value: '-'
    },
    {
        type: (0, $5J7Qx.BranchTemplateType).PLACEHOLDER,
        value: (0, $5J7Qx.PlaceholderEnum).ISSUE_SUMMARY
    },
    {
        type: (0, $5J7Qx.BranchTemplateType).TEXT,
        value: ''
    }
];
const $eaa7cf347c6ebe70$export$f1c9dd0f5207dd5e = 'Tab';
const $eaa7cf347c6ebe70$export$59f214baefff6196 = 'ArrowDown';
const $eaa7cf347c6ebe70$export$8188339dbe6c99c4 = 'ArrowUp';
const $eaa7cf347c6ebe70$export$8d4f84cc5dc5fc15 = 'ArrowLeft';
const $eaa7cf347c6ebe70$export$e9510a4613bb01df = 'ArrowRight';
const $eaa7cf347c6ebe70$export$806b905ec7df742f = 'Enter';
const $eaa7cf347c6ebe70$export$acae31b32a99bba9 = 'Backspace';
const $eaa7cf347c6ebe70$export$4bd2facc4a3e6aa1 = 'Delete';
const $eaa7cf347c6ebe70$export$c8fc15cbe86018cf = 9;
const $eaa7cf347c6ebe70$export$ef4126220d897037 = 40;
const $eaa7cf347c6ebe70$export$350d8b99a00c926e = 38;
const $eaa7cf347c6ebe70$export$e774cc0768ea4dc1 = 37;
const $eaa7cf347c6ebe70$export$31ed5928f4dcb259 = 39;
const $eaa7cf347c6ebe70$export$772f5b3bcf01463 = 13;
const $eaa7cf347c6ebe70$export$707d117a1ef29221 = 8;
const $eaa7cf347c6ebe70$export$229ec1b1cfee860b = 46;
const $eaa7cf347c6ebe70$export$4f8e512aaddfeb04 = 250;
const $eaa7cf347c6ebe70$export$1817f9c591be5d87 = 'git checkout -b';
const $eaa7cf347c6ebe70$export$103bedf43ba882db = 'error';
const $eaa7cf347c6ebe70$export$64fdd419ec8dbc36 = 'warning';
const $eaa7cf347c6ebe70$export$4f363a1643a5c272 = // We need control character pattern matching to comply with Git's ref format
// eslint-disable-next-line no-control-regex
/(^|[/.])([/.]|$)|^@$|@{|[\x00-\x20\x7f~^:?*;"'`&|$()!\][\\]|\.lock(\/|$)|\s/g;

});
parcelRegister("5J7Qx", function(module, exports) {

$parcel$export(module.exports, "PlaceholderEnum", () => $bb5d4f08fe6e0752$export$83a26ecbeb7da185);
$parcel$export(module.exports, "BranchTemplateType", () => $bb5d4f08fe6e0752$export$8aa063a04e39c752);
const $bb5d4f08fe6e0752$export$83a26ecbeb7da185 = {
    ISSUE_KEY: 'issueKey',
    ISSUE_SUMMARY: 'issueSummary',
    ISSUE_SUMMARY_SHORT: 'issueSummaryShort',
    ISSUE_TYPE: 'issueType',
    PROJECT_KEY: 'projectKey'
};
const $bb5d4f08fe6e0752$export$8aa063a04e39c752 = {
    TEXT: 'TEXT',
    PLACEHOLDER: 'PLACEHOLDER'
};

});


parcelRegister("18yLj", function(module, exports) {

$parcel$export(module.exports, "getBranchTemplate", () => $784e538e73eb7797$export$514aa7ab9be9e739);
$parcel$export(module.exports, "getBranchSettings", () => $784e538e73eb7797$export$7d4957ca5a2b6c36);
$parcel$export(module.exports, "setInitialState", () => $784e538e73eb7797$export$17a469542330eb1b);
$parcel$export(module.exports, "restoreFocusAfterDeletingAllText", () => $784e538e73eb7797$export$115ba9b4d813d40);
$parcel$export(module.exports, "setEmptyTextStarterTemplates", () => $784e538e73eb7797$export$a56e2c50ad04f20a);
$parcel$export(module.exports, "setDefaultTemplates", () => $784e538e73eb7797$export$306cf5a0989ece24);
$parcel$export(module.exports, "setUserEnteredTemplate", () => $784e538e73eb7797$export$be1c83975a266890);
$parcel$export(module.exports, "setCaretPosition", () => $784e538e73eb7797$export$97ab23b40042f8af);
$parcel$export(module.exports, "insertPlaceholder", () => $784e538e73eb7797$export$93bd7e21ec24d5a4);
$parcel$export(module.exports, "removePlaceholder", () => $784e538e73eb7797$export$2e7311d25c70abda);
$parcel$export(module.exports, "saveUserConfigBranchData", () => $784e538e73eb7797$export$5d8e34360f237a1b);
$parcel$export(module.exports, "getUserConfigBranchData", () => $784e538e73eb7797$export$7ca6c0c3719afbb8);
$parcel$export(module.exports, "setBranchData", () => $784e538e73eb7797$export$76dea67fbc11f21b);
$parcel$export(module.exports, "setFocusTagIndex", () => $784e538e73eb7797$export$23556ac160319730);
$parcel$export(module.exports, "setRestoreFocus", () => $784e538e73eb7797$export$e71e64a53e05e7a4);
$parcel$export(module.exports, "setIsGitCommandIncluded", () => $784e538e73eb7797$export$6004d0b86f5fafd);

var $7Jxgt = parcelRequire("7Jxgt");

var $5BU3N = parcelRequire("5BU3N");

var $5J7Qx = parcelRequire("5J7Qx");

var $cyM5P = parcelRequire("cyM5P");

var $dFQCk = parcelRequire("dFQCk");
const $784e538e73eb7797$var$getPlaceHoldersLength = (template)=>template.filter((item)=>item.type === (0, $5J7Qx.BranchTemplateType).PLACEHOLDER).length;
const $784e538e73eb7797$export$514aa7ab9be9e739 = (branchSettings)=>Array.isArray(branchSettings) ? branchSettings : branchSettings.branchNameTemplate;
const $784e538e73eb7797$export$7d4957ca5a2b6c36 = (branchSettings, isGitCommandIncluded = true)=>Array.isArray(branchSettings) ? {
        branchNameTemplate: branchSettings,
        version: 'v2',
        isGitCommandIncluded: isGitCommandIncluded
    } : branchSettings;
const $784e538e73eb7797$var$getInitialState = (templates)=>{
    const userBranchSettings = $784e538e73eb7797$export$7d4957ca5a2b6c36(templates);
    const { branchNameTemplate: branchNameTemplate } = userBranchSettings;
    const newBranchNameSettings = {};
    const defaultTemplates = Array.from(branchNameTemplate);
    return {
        uniqueKey: (0, $7Jxgt.v4)(),
        writeOnlyTemplates: defaultTemplates,
        readAndWriteTemplates: defaultTemplates,
        originalTemplates: defaultTemplates,
        caretPosition: {
            templateIndex: $784e538e73eb7797$var$getPlaceHoldersLength(defaultTemplates),
            characterIndex: 0
        },
        isLoading: false,
        isSaving: false,
        saveError: null,
        focusTagIndex: 0,
        ...newBranchNameSettings
    };
};
const $784e538e73eb7797$export$17a469542330eb1b = (templates)=>({ setState: setState })=>{
        const initialState = $784e538e73eb7797$var$getInitialState(templates);
        setState({
            ...initialState
        });
    };
const $784e538e73eb7797$export$115ba9b4d813d40 = ()=>({ setState: setState, getState: getState })=>{
        const { caretPosition: caretPosition, writeOnlyTemplates: writeOnlyTemplates, readAndWriteTemplates: readAndWriteTemplates } = getState();
        const lastTemplate = readAndWriteTemplates[readAndWriteTemplates.length - 1];
        const isLastTemplateATag = lastTemplate.type === (0, $5J7Qx.BranchTemplateType).PLACEHOLDER;
        if (writeOnlyTemplates.length === readAndWriteTemplates.length + 2) // a tag along with a text has been deleted with BACKSPACE (not DELETE)
        {
            if (caretPosition.templateIndex > 0) setState({
                uniqueKey: (0, $7Jxgt.v4)(),
                writeOnlyTemplates: readAndWriteTemplates,
                caretPosition: {
                    templateIndex: caretPosition.templateIndex - 1,
                    characterIndex: 0
                },
                restoreFocus: true
            });
        } else if (readAndWriteTemplates.length % 2 === 0 && isLastTemplateATag) {
            // tag template at the end
            const updatedTemplates = (0, $dFQCk.handleEndTagTemplate)(readAndWriteTemplates);
            setState({
                uniqueKey: (0, $7Jxgt.v4)(),
                readAndWriteTemplates: updatedTemplates,
                writeOnlyTemplates: updatedTemplates,
                caretPosition: {
                    templateIndex: caretPosition.templateIndex,
                    characterIndex: 0
                },
                restoreFocus: true
            });
        } else if (readAndWriteTemplates.length % 2 === 0) {
            // even number of templates, insert text between tags
            const updatedTemplates = (0, $dFQCk.handleConsecutiveTagTemplates)(readAndWriteTemplates);
            setState({
                uniqueKey: (0, $7Jxgt.v4)(),
                readAndWriteTemplates: updatedTemplates,
                writeOnlyTemplates: updatedTemplates,
                caretPosition: {
                    templateIndex: caretPosition.templateIndex - 1,
                    characterIndex: 0
                },
                restoreFocus: true
            });
        } else // only text is deleted with DELETE or BACKSPACE
        setState({
            uniqueKey: (0, $7Jxgt.v4)(),
            writeOnlyTemplates: readAndWriteTemplates,
            restoreFocus: true
        });
    };
const $784e538e73eb7797$export$a56e2c50ad04f20a = ()=>({ setState: setState })=>{
        const emptyTextWrapper = [
            (0, $5BU3N.initialTemplates)[0]
        ];
        setState({
            uniqueKey: (0, $7Jxgt.v4)(),
            writeOnlyTemplates: emptyTextWrapper,
            readAndWriteTemplates: emptyTextWrapper,
            caretPosition: {
                templateIndex: 0,
                characterIndex: 0
            },
            restoreFocus: true
        });
    };
const $784e538e73eb7797$export$306cf5a0989ece24 = ()=>({ setState: setState })=>{
        const defaultTemplates = Array.from((0, $5BU3N.initialTemplates));
        setState({
            uniqueKey: (0, $7Jxgt.v4)(),
            writeOnlyTemplates: defaultTemplates,
            // need hard refresh the state make it re-render
            readAndWriteTemplates: defaultTemplates,
            focusTagIndex: 0,
            // after reset, set the focus at the end of the input
            caretPosition: {
                templateIndex: $784e538e73eb7797$var$getPlaceHoldersLength(defaultTemplates),
                characterIndex: 0
            },
            restoreFocus: true,
            saveError: null
        });
    };
const $784e538e73eb7797$export$be1c83975a266890 = (templates)=>({ setState: setState })=>{
        const mergedTemplates = (0, $dFQCk.mergeConsecutiveTextTemplates)([
            ...templates
        ], true);
        const merged = mergedTemplates.length !== templates.length;
        if (merged) setState({
            uniqueKey: (0, $7Jxgt.v4)(),
            readAndWriteTemplates: mergedTemplates,
            writeOnlyTemplates: mergedTemplates,
            focusTagIndex: 0,
            restoreFocus: true
        });
        else setState({
            readAndWriteTemplates: templates
        });
    };
const $784e538e73eb7797$export$97ab23b40042f8af = (caretPosition)=>({ setState: setState })=>{
        setState({
            caretPosition: caretPosition
        });
    };
const $784e538e73eb7797$export$93bd7e21ec24d5a4 = (placeholder)=>({ getState: getState, setState: setState })=>{
        const { readAndWriteTemplates: readAndWriteTemplates, caretPosition: caretPosition } = getState();
        // clone array as we use in-place modification of array
        // so sweet state can detect the change
        const modifiedTemplates = Array.from((0, $dFQCk.insertPlaceholderIntoState)(caretPosition, readAndWriteTemplates, placeholder));
        const updatedCaretPosition = {
            templateIndex: caretPosition.templateIndex + 1,
            characterIndex: 0
        };
        setState({
            uniqueKey: (0, $7Jxgt.v4)(),
            readAndWriteTemplates: modifiedTemplates,
            writeOnlyTemplates: modifiedTemplates,
            focusTagIndex: 0,
            caretPosition: updatedCaretPosition,
            restoreFocus: true
        });
    };
const $784e538e73eb7797$export$2e7311d25c70abda = (placeholder, placeholderIndex, removedWithKeyboard)=>({ getState: getState, setState: setState })=>{
        const { readAndWriteTemplates: readAndWriteTemplates } = getState();
        // clone array as we use in-place modification of array
        // so sweet state can detect the change
        const modifiedTemplates = Array.from((0, $dFQCk.removePlaceholderFromState)(readAndWriteTemplates, placeholder, placeholderIndex, removedWithKeyboard));
        const updatedCaretPosition = (0, $dFQCk.getUpdatedCaretPosition)(placeholderIndex, readAndWriteTemplates, removedWithKeyboard);
        setState({
            uniqueKey: (0, $7Jxgt.v4)(),
            readAndWriteTemplates: modifiedTemplates,
            writeOnlyTemplates: modifiedTemplates,
            focusTagIndex: 0,
            ...!removedWithKeyboard && {
                caretPosition: updatedCaretPosition,
                restoreFocus: true
            }
        });
    };
const $784e538e73eb7797$export$27f339617553b33b = (accountId, userInput, // eslint-disable-next-line @typescript-eslint/no-explicit-any
setState)=>{
    const userBranchSettings = $784e538e73eb7797$export$514aa7ab9be9e739(userInput);
    return (0, $cyM5P.setUserBranchConfigTemplates)(accountId, (0, $5BU3N.PROPERTY_KEY), userBranchSettings).then(()=>{
        setState({
            isSaving: false,
            originalTemplates: userBranchSettings
        });
        return true;
    }).catch((err)=>{
        setState({
            isSaving: false,
            saveError: err.message
        });
        return false;
    });
};
const $784e538e73eb7797$export$fdb7f1543a9fc37 = (accountId, setState)=>(0, $cyM5P.getUserBranchConfigTemplates)(accountId, (0, $5BU3N.PROPERTY_KEY)).then((res)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const initialState = $784e538e73eb7797$var$getInitialState(res);
        setState({
            ...initialState
        });
    }).catch(()=>{
        const initialState = $784e538e73eb7797$var$getInitialState((0, $5BU3N.initialTemplates));
        setState({
            ...initialState
        });
    });
const $784e538e73eb7797$export$5d8e34360f237a1b = (accountId, readAndWriteTemplates)=>({ setState: setState })=>{
        const { branchNameTemplate: branchNameTemplate, isGitCommandIncluded: isGitCommandIncluded } = $784e538e73eb7797$export$7d4957ca5a2b6c36(readAndWriteTemplates);
        setState({
            uniqueKey: (0, $7Jxgt.v4)(),
            writeOnlyTemplates: branchNameTemplate,
            readAndWriteTemplates: branchNameTemplate,
            caretPosition: {
                templateIndex: $784e538e73eb7797$var$getPlaceHoldersLength(branchNameTemplate),
                characterIndex: 0
            },
            isSaving: true,
            saveError: null,
            focusTagIndex: 0,
            isGitCommandIncluded: isGitCommandIncluded
        });
        return $784e538e73eb7797$export$27f339617553b33b(accountId, readAndWriteTemplates, setState);
    };
const $784e538e73eb7797$export$7ca6c0c3719afbb8 = (accountId)=>({ setState: setState })=>{
        setState({
            isLoading: true
        });
        return $784e538e73eb7797$export$fdb7f1543a9fc37(accountId, setState);
    };
const $784e538e73eb7797$export$76dea67fbc11f21b = (branchData)=>({ setState: setState })=>{
        setState({
            branchData: branchData
        });
    };
const $784e538e73eb7797$export$23556ac160319730 = (focusTagIndex)=>({ setState: setState })=>{
        setState({
            focusTagIndex: focusTagIndex
        });
    };
const $784e538e73eb7797$export$e71e64a53e05e7a4 = (restoreFocus)=>({ setState: setState })=>{
        setState({
            restoreFocus: restoreFocus
        });
    };
const $784e538e73eb7797$export$6004d0b86f5fafd = (isGitCommandIncluded)=>({ setState: setState })=>{
        setState({
            isGitCommandIncluded: isGitCommandIncluded
        });
    };

});
parcelRegister("cyM5P", function(module, exports) {

$parcel$export(module.exports, "getUserBranchConfigTemplates", () => $2a843853d9431d0f$export$12f2a339ce9f8976);
$parcel$export(module.exports, "setUserBranchConfigTemplates", () => $2a843853d9431d0f$export$a881f7c12c765ce6);

var $89SaW = parcelRequire("89SaW");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");
const $2a843853d9431d0f$export$12f2a339ce9f8976 = (accountId, propertyKey)=>accountId ? (0, $89SaW.getUserProperty)(accountId, propertyKey).catch((error)=>{
        // If we can't find key, we know user never save his branch config template
        if (error.statusCode === 404) return null;
        (0, $2YZCu.default).safeErrorWithoutCustomerData('getUserBranchConfigTemplates', `Error reading data from getUserBranchConfigTemplates with property key ${propertyKey}`, error);
        return null;
    }) : new Promise((resolve)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('getUserBranchConfigTemplates', `Failed to get getUserBranchConfigTemplates with property key ${propertyKey} - no accountId`);
        return resolve(null);
    });
const $2a843853d9431d0f$export$a881f7c12c765ce6 = (accountId, propertyKey, userBranchSettings)=>accountId ? (0, $89SaW.setUserProperties)(accountId, propertyKey, JSON.stringify(userBranchSettings)).then((res)=>{
        if (res.ok) return res;
        return res.text().then((errResp)=>{
            throw new (0, $jJZqs.default)(res.status, errResp);
        });
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('setUserBranchConfigTemplates', `Failed to update template value in setUserBranchConfigTemplates with property key ${propertyKey}`, error);
        throw new Error('Failed to save');
    }) : new Promise(()=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('setUserBranchConfigTemplates', `Failed to update template value in setUserBranchConfigTemplates with property key ${propertyKey} - no accountId`);
        throw new Error('No AccountId');
    });

});

parcelRegister("dFQCk", function(module, exports) {

$parcel$export(module.exports, "getUpdatedCaretPosition", () => $3d5a4e65ac3a1a8a$export$ebeb36435dbd8c09);
$parcel$export(module.exports, "handleConsecutiveTagTemplates", () => $3d5a4e65ac3a1a8a$export$d9ecd1b91ef53477);
$parcel$export(module.exports, "handleEndTagTemplate", () => $3d5a4e65ac3a1a8a$export$3e6ce6fb5d60fc32);
$parcel$export(module.exports, "mergeConsecutiveTextTemplates", () => $3d5a4e65ac3a1a8a$export$9b49bd5a514b024b);
$parcel$export(module.exports, "removePlaceholderFromState", () => $3d5a4e65ac3a1a8a$export$21882bab6686a4a1);
$parcel$export(module.exports, "insertPlaceholderIntoState", () => $3d5a4e65ac3a1a8a$export$8462f46c43e04a63);

var $LpImS = parcelRequire("LpImS");

var $5J7Qx = parcelRequire("5J7Qx");
const $3d5a4e65ac3a1a8a$var$separatorTemplate = {
    type: (0, $5J7Qx.BranchTemplateType).TEXT,
    value: '-'
};
const $3d5a4e65ac3a1a8a$var$textTemplate = (value)=>({
        type: (0, $5J7Qx.BranchTemplateType).TEXT,
        value: value
    });
const $3d5a4e65ac3a1a8a$var$tagTemplate = (placeholder)=>({
        type: (0, $5J7Qx.BranchTemplateType).PLACEHOLDER,
        value: placeholder
    });
const $3d5a4e65ac3a1a8a$var$insertAtFirstCharacterOfInput = (readAndWriteTemplates, placeholder)=>{
    // insert a separator after the tag
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(readAndWriteTemplates);
    if (newUserConfigTemplates.length > 1) newUserConfigTemplates[0].value = `${$3d5a4e65ac3a1a8a$var$separatorTemplate.value}${newUserConfigTemplates[0].value}`;
    newUserConfigTemplates.unshift($3d5a4e65ac3a1a8a$var$textTemplate(''), $3d5a4e65ac3a1a8a$var$tagTemplate(placeholder));
    return newUserConfigTemplates;
};
const $3d5a4e65ac3a1a8a$export$ebeb36435dbd8c09 = (placeholderIndex, previousTemplates, removedWithKeyboard)=>{
    const templateIndex = Math.ceil((placeholderIndex + 1) / 2) - 1;
    const previousTextTemplate = previousTemplates[placeholderIndex - 1];
    const currentTextTemplate = previousTemplates[placeholderIndex + 1];
    const characterIndexForRemovedViaCrossButton = previousTextTemplate.value.endsWith('-') && currentTextTemplate.value.length === 0 ? previousTextTemplate.value.length - 1 : previousTextTemplate.value.length;
    const characterIndex = removedWithKeyboard ? previousTextTemplate.value.length : characterIndexForRemovedViaCrossButton;
    return {
        templateIndex: templateIndex,
        characterIndex: characterIndex
    };
};
const $3d5a4e65ac3a1a8a$var$insertAtFirstCharacterAfterTag = (positionIndex, readAndWriteTemplates, placeholder)=>{
    // insert a separator before and after the tag
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(readAndWriteTemplates);
    const endText = readAndWriteTemplates[positionIndex].value;
    const endTextWithPrefix = endText.startsWith('-') || !endText ? endText : `-${endText}`;
    newUserConfigTemplates.splice(positionIndex, 1, $3d5a4e65ac3a1a8a$var$separatorTemplate, $3d5a4e65ac3a1a8a$var$tagTemplate(placeholder), $3d5a4e65ac3a1a8a$var$textTemplate(endTextWithPrefix));
    return newUserConfigTemplates;
};
const $3d5a4e65ac3a1a8a$export$d9ecd1b91ef53477 = (readAndWriteTemplates)=>{
    for(let i = 0; i < readAndWriteTemplates.length - 1; i += 1)if (readAndWriteTemplates[i].type === (0, $5J7Qx.BranchTemplateType).PLACEHOLDER && readAndWriteTemplates[i + 1].type === (0, $5J7Qx.BranchTemplateType).PLACEHOLDER) {
        readAndWriteTemplates.splice(i + 1, 0, $3d5a4e65ac3a1a8a$var$textTemplate(''));
        return readAndWriteTemplates;
    }
    return readAndWriteTemplates;
};
const $3d5a4e65ac3a1a8a$export$3e6ce6fb5d60fc32 = (readAndWriteTemplates)=>{
    const lastTemplate = readAndWriteTemplates[readAndWriteTemplates.length - 1];
    if (lastTemplate.type === (0, $5J7Qx.BranchTemplateType).PLACEHOLDER) {
        readAndWriteTemplates.splice(readAndWriteTemplates.length, 0, $3d5a4e65ac3a1a8a$var$textTemplate(''));
        return readAndWriteTemplates;
    }
    return readAndWriteTemplates;
};
const $3d5a4e65ac3a1a8a$export$9b49bd5a514b024b = (readAndWriteTemplates, removedWithKeyboard)=>{
    for(let i = 0; i < readAndWriteTemplates.length - 1; i += 1)if (readAndWriteTemplates[i].type === (0, $5J7Qx.BranchTemplateType).TEXT && readAndWriteTemplates[i + 1].type === (0, $5J7Qx.BranchTemplateType).TEXT) {
        // merge the text of 2nd text node with the 1st node and
        // remove the 2nd text tag
        const beginText = readAndWriteTemplates[i].value;
        const endText = readAndWriteTemplates[i + 1].value;
        const beginTextEndWithSuffix = beginText.endsWith('-');
        const endTextStartWithPrefix = endText.startsWith('-');
        let finalSuffixedText;
        if (!beginText && endText && endTextStartWithPrefix) finalSuffixedText = endText.substring(1);
        else if (!endText && beginText && beginTextEndWithSuffix) finalSuffixedText = beginText.slice(0, -1);
        else if (beginTextEndWithSuffix && endTextStartWithPrefix) finalSuffixedText = beginText.slice(0, -1) + endText;
        else finalSuffixedText = beginText + endText;
        finalSuffixedText = finalSuffixedText === '--' ? '-' : finalSuffixedText;
        /**
			 * Keep hyphens when the tag was removed with keyboard to avoid jank
			 */ const finalText = removedWithKeyboard ? $3d5a4e65ac3a1a8a$var$textTemplate(`${beginText}${endText}`) : $3d5a4e65ac3a1a8a$var$textTemplate(finalSuffixedText);
        readAndWriteTemplates.splice(i, 2, finalText);
        return readAndWriteTemplates;
    }
    return readAndWriteTemplates;
};
const $3d5a4e65ac3a1a8a$var$insertInTheMiddle = (positionIndex, characterIndex, currentNodeText, readAndWriteTemplates, placeholder)=>{
    const beginText = currentNodeText.substring(0, characterIndex);
    const endText = currentNodeText.substring(characterIndex);
    const noPrefixRequired = endText.startsWith('-') || endText === '' && positionIndex === readAndWriteTemplates.length - 1;
    const beginTextWithSuffix = beginText.endsWith('-') ? beginText : `${beginText}-`;
    const endTextWithPrefix = noPrefixRequired ? endText : `-${endText}`;
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(readAndWriteTemplates);
    newUserConfigTemplates.splice(positionIndex, 1, $3d5a4e65ac3a1a8a$var$textTemplate(beginTextWithSuffix), $3d5a4e65ac3a1a8a$var$tagTemplate(placeholder), $3d5a4e65ac3a1a8a$var$textTemplate(endTextWithPrefix));
    return newUserConfigTemplates;
};
const $3d5a4e65ac3a1a8a$export$21882bab6686a4a1 = (originalTemplates, placeholderToRemove, placeholderIndex, removedWithKeyboard)=>{
    const readAndWriteTemplates = [
        ...originalTemplates
    ];
    for(let i = 0; i < readAndWriteTemplates.length; i += 1)if (readAndWriteTemplates[i].type === (0, $5J7Qx.BranchTemplateType).PLACEHOLDER && readAndWriteTemplates[i].value === placeholderToRemove && i === placeholderIndex) {
        // we have reached the tag we want to remove
        readAndWriteTemplates.splice(i, 1);
        return $3d5a4e65ac3a1a8a$export$9b49bd5a514b024b(readAndWriteTemplates, removedWithKeyboard);
    }
    return readAndWriteTemplates;
};
const $3d5a4e65ac3a1a8a$export$8462f46c43e04a63 = (caretPosition, readAndWriteTemplates, placeholder)=>{
    let templatesYetToScan = caretPosition.templateIndex;
    const newUserConfigTemplates = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(readAndWriteTemplates);
    for(let i = 0; i < newUserConfigTemplates.length; i += 1){
        if (templatesYetToScan === 0 && newUserConfigTemplates[i].type === (0, $5J7Qx.BranchTemplateType).TEXT) {
            // we have reached the template we want to insert the new placeholder into
            if (caretPosition.templateIndex === 0 && caretPosition.characterIndex === 0) return $3d5a4e65ac3a1a8a$var$insertAtFirstCharacterOfInput(newUserConfigTemplates, placeholder);
            if (caretPosition.characterIndex === 0) return $3d5a4e65ac3a1a8a$var$insertAtFirstCharacterAfterTag(i, newUserConfigTemplates, placeholder);
            return $3d5a4e65ac3a1a8a$var$insertInTheMiddle(i, caretPosition.characterIndex, newUserConfigTemplates[i].value, newUserConfigTemplates, placeholder);
        }
        if (newUserConfigTemplates[i].type === (0, $5J7Qx.BranchTemplateType).PLACEHOLDER) templatesYetToScan -= 1;
    }
    return newUserConfigTemplates;
};

});



parcelRegister("gkNob", function(module, exports) {

$parcel$export(module.exports, "createBranchDropdownContentEntrypoint", () => $b125bcbc30169b8c$export$c026a3a54773365f);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b125bcbc30169b8c$export$c026a3a54773365f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lWYeR")), {
        moduleId: "7680ecf8"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lWYeR", function(module, exports) {

let $ffadbde19e1778b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffadbde19e1778b8$var$load("kNNQL").then(()=>parcelRequire('1acZr'));

});




//# sourceMappingURL=index-new.5a8ba089.js.map
